const getBreadcrumbsItems = (itemsArray) => {
	const itemsObject = itemsArray.map((item, index) => {
		return `{
			"@type": "ListItem",
			"position": "${index + 1}",
			"name": "${item.text.replace(/\b\w/g, c => c.toUpperCase()).replace("-", " ")}",
			"item": "${item.link}"
		}`
	})
	return itemsObject
}

export const getBreadcrumbSchema = (urlBase, tipoOperacionFamilia, tipoPropiedadFamilia, region, comuna, chain) => {

	if (urlBase === "" || urlBase === undefined || urlBase === null)
		return "";

	const linkTof = tipoOperacionFamilia ? [urlBase, tipoOperacionFamilia] : [urlBase];
	const linkChain = chain ? [...linkTof, chain] : linkTof;
	const linkTpf = tipoPropiedadFamilia ? [...linkChain, tipoPropiedadFamilia] : linkChain;
	const linkRegion = region ? [...linkTpf, region] : linkTpf;
	const linkComuna = comuna ? [...linkRegion, comuna] : linkRegion;

	const itemsArray = [];
	itemsArray.push({ link: urlBase, text: "Inicio" });
	tipoOperacionFamilia && itemsArray.push({ link: linkTof.join("/"), text: tipoOperacionFamilia });
	tipoPropiedadFamilia && itemsArray.push({ link: linkTpf.join("/"), text: tipoPropiedadFamilia });
	region && itemsArray.push({ link: linkRegion.join("/"), text: region });
	comuna && itemsArray.push({ link: linkComuna.join("/"), text: comuna });

	return `{
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
			${getBreadcrumbsItems(itemsArray)}
		]
	}`
}